import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Renders a milestone thumbnail given its storage path.
 *
 * The component figures out which file endpoint to hit:
 * - If `shareToken` is provided → public `/shared/{token}/files/...` (no auth).
 * - Otherwise → authenticated `/files/...` (axios interceptor adds Bearer).
 *
 * Returns null while loading; renders the children fallback when the path is
 * empty or fetching failed.
 */
export function MilestoneThumb({ path, shareToken, alt = "Milestone", className = "" }) {
  const [src, setSrc] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let mounted = true;
    let revokeUrl = null;
    setSrc(null);
    setFailed(false);
    if (!path) return undefined;
    const url = shareToken
      ? `${API}/shared/${shareToken}/files/${path}`
      : `${API}/files/${path}`;
    const config = shareToken ? { responseType: "blob" } : { responseType: "blob" };
    axios.get(url, config)
      .then((r) => {
        if (!mounted) return;
        revokeUrl = URL.createObjectURL(r.data);
        setSrc(revokeUrl);
      })
      .catch((err) => {
        console.debug("[MilestoneThumb]", err);
        if (mounted) setFailed(true);
      });
    return () => {
      mounted = false;
      if (revokeUrl) URL.revokeObjectURL(revokeUrl);
    };
  }, [path, shareToken]);

  if (!path || failed) return null;
  if (!src) return <div className={`${className} opacity-50`} />;
  return <img src={src} alt={alt} className={className} />;
}
